export const translations = {
  en: {
    nav: {
      services: "Services",
      industries: "Industries",
      method: "Methodology",
      healthcheck: "Health Check",
      contact: "Contact",
      cta: "Free Health Check",
    },
    hero: {
      overline: "VISION 2030 ALIGNED · RIYADH, KSA",
      title: "Financial clarity for Saudi Arabia's ambitious SMEs.",
      sub: "Capital Bay's Financial Management Review uncovers hidden cash, tightens controls, and prepares your business for funding, growth, and Zakat/VAT excellence.",
      cta1: "Start the CEO Health Check",
      cta2: "Talk on WhatsApp",
      stat1: "120+",
      stat1l: "SME engagements",
      stat2: "12%",
      stat2l: "avg. margin uplift",
      stat3: "10",
      stat3l: "core KSA industries",
      stat4: "10 days",
      stat4l: "to first findings",
    },
    industries: {
      overline: "BUILT FOR YOUR INDUSTRY",
      title: "Specialised expertise across 24+ Saudi sectors.",
      sub: "From heavy industry to boutique consulting practices and freelance-led firms — our financial review playbooks are calibrated to the operating realities, KPIs and regulatory nuances of every industry.",
    },
    services: {
      overline: "WHAT WE DO",
      title: "Financial Management Review — and everything around it.",
      sub: "A senior-led engagement that gives CEOs a clear, actionable picture of their finance function in 4–6 weeks.",
      items: [
        { t: "Financial Management Review", d: "End-to-end diagnostic across cash flow, profitability, compliance, controls and growth readiness — with a prioritised remediation roadmap." },
        { t: "Internal Controls & Risk", d: "Segregation of duties, approval matrices, fraud risk assessment, and SOX-style control testing tailored to SMEs." },
        { t: "Zakat, VAT & ZATCA", d: "Filing reconciliations, e-invoicing readiness (Phase 2), and policy documentation to keep you penalty-free." },
        { t: "FP&A & Dashboards", d: "Rolling forecasts, board packs, KPI dashboards delivered within 10 days of month-end." },
        { t: "Working Capital Optimisation", d: "DSO/DPO/DIO reset, supplier terms renegotiation, and cash conversion cycle improvements." },
        { t: "Funding & Investor Readiness", d: "Information memoranda, IFRS-aligned financials, and data rooms for debt or equity raises." },
      ],
    },
    method: {
      overline: "OUR METHODOLOGY",
      title: "A four-stage review designed for clarity and speed.",
      steps: [
        { n: "01", t: "Discover", d: "Stakeholder interviews, document request, and benchmarking against your industry." },
        { n: "02", t: "Diagnose", d: "Quantitative review across 5 finance pillars; root-cause analysis." },
        { n: "03", t: "Design", d: "Prioritised roadmap, quick-wins, and a 12-month transformation plan." },
        { n: "04", t: "Deliver", d: "Board-ready report, executive workshop, and 90-day implementation oversight." },
      ],
    },
    quiz: {
      overline: "FREE LEAD MAGNET",
      title: "CEO Financial Management Health Check",
      sub: "12 questions. 4 minutes. A personalised score, category breakdown, and the top three improvements for your business — calibrated to your industry.",
      pickIndustry: "1. Select your industry",
      pickIndustrySub: "Choose the sector that best describes your core business.",
      next: "Continue",
      back: "Back",
      submit: "Calculate my score",
      progress: "Question",
      of: "of",
      qHelp: "Pick the option that best reflects your reality today.",
      ans: { yes: "Yes — fully in place", partial: "Partially / sometimes", no: "No / not yet" },
      formTitle: "2. Where should we send your report?",
      formSub: "We'll show your score on screen and email a detailed PDF.",
      f: {
        name: "Full name",
        role: "Your role",
        email: "Work email",
        phone: "Phone (with country code)",
        company: "Company name",
        size: "Company size",
        sizes: ["1–10 employees", "11–50", "51–200", "201–500", "500+"],
        consent: "I agree to be contacted about my results.",
      },
      results: {
        title: "Your CEO Financial Management Score",
        sub: "Here's how your finance function stacks up across the five pillars we review.",
        gradeLabel: "Overall grade",
        recsTitle: "Your top 3 priorities",
        cta: "Book a discovery call on WhatsApp",
        share: "Share on LinkedIn",
        restart: "Run another check",
      },
      cats: {
        cash_flow: "Cash Flow",
        profitability: "Profitability",
        compliance: "Compliance",
        controls: "Controls",
        growth: "Growth Readiness",
      },
    },
    why: {
      overline: "WHY CAPITAL BAY",
      title: "Senior advisors. KSA fluency. Boardroom-ready output.",
      items: [
        { t: "Senior-led, always", d: "Every engagement is delivered by partners with Big-4 backgrounds — never juniors." },
        { t: "KSA market depth", d: "Fluent in Zakat, VAT, ZATCA, SAMA, CMA, and Vision 2030 priorities." },
        { t: "Bilingual delivery", d: "Reports, workshops and dashboards in Arabic and English." },
        { t: "Outcome-aligned", d: "Findings tied to measurable financial impact — not generic best practice." },
      ],
    },
    testimonials: {
      overline: "WHAT CEOS SAY",
      title: "Trusted by founders, family-owned groups and PE-backed SMEs.",
      items: [
        { q: "Capital Bay rebuilt our cash forecast and unlocked SAR 6.4M in working capital within 90 days.", a: "CEO, F&B group, Riyadh" },
        { q: "The review gave our board the clarity we needed before our Series B raise. Investor-ready in six weeks.", a: "Founder, ICT scale-up, Jeddah" },
        { q: "Their ZATCA Phase 2 remediation saved us from a material penalty exposure.", a: "CFO, Manufacturing SME, Dammam" },
      ],
    },
    faq: {
      overline: "QUESTIONS",
      title: "Frequently asked questions.",
      items: [
        { q: "How long does a Financial Management Review take?", a: "Typically 4–6 weeks, depending on company size and data readiness. Initial findings are shared within 10 working days." },
        { q: "Do you work with companies outside Riyadh?", a: "Yes. We serve SMEs across all KSA regions and frequently work with groups headquartered in Jeddah, Dammam, and the Eastern Province." },
        { q: "Is the CEO Health Check really free?", a: "Yes — the quiz, score, category breakdown, and top three recommendations are free. A full review is a separate paid engagement." },
        { q: "Will my data stay confidential?", a: "Absolutely. We sign NDAs with every client and the Health Check captures only the information you choose to share." },
        { q: "Can you support ZATCA Phase 2 e-invoicing?", a: "Yes — we provide readiness assessments, integration design, and post-go-live monitoring." },
      ],
    },
    contact: {
      overline: "GET IN TOUCH",
      title: "Let's talk about your finance function.",
      sub: "Send a message or chat with us instantly on WhatsApp.",
      name: "Your name",
      email: "Email",
      phone: "Phone",
      company: "Company",
      message: "How can we help?",
      send: "Send message",
      address: "Al Malaz, Riyadh, Kingdom of Saudi Arabia",
      email_label: "Email",
      email_value: "capital.bay@outlook.com",
      phone_label: "WhatsApp",
      phone_value: "",
      sent: "Message sent. We'll reply within one business day.",
    },
    footer: {
      tag: "Financial Management Review for KSA SMEs.",
      links: "Navigate",
      services: "Services",
      industries: "Industries",
      contact: "Contact",
      healthcheck: "Health Check",
      copyright: "© Capital Bay Consulting & Management Solutions. All rights reserved.",
      vision: "Aligned with Saudi Vision 2030",
    },
    industriesList: {
      oil_gas: "Oil, Gas & Petrochemicals",
      construction: "Construction & Real Estate",
      retail: "Retail & E-commerce",
      healthcare: "Healthcare & Pharma",
      manufacturing: "Manufacturing & Industrial",
      hospitality: "Tourism & Hospitality",
      logistics: "Logistics & Transportation",
      financial: "Financial Services",
      ict: "ICT & Technology",
      fnb: "Food & Beverage",
      professional_services: "Professional Services & Law",
      creative_agencies: "Advertising & Creative Agencies",
      media: "Media, Publishing & Content",
      education: "Education & EdTech",
      architecture: "Architecture & Engineering",
      beauty_wellness: "Beauty, Spa & Wellness",
      fitness: "Fitness & Sports Studios",
      events: "Events & Entertainment",
      renewables: "Renewables & CleanTech",
      agritech: "Agriculture & AgriTech",
      automotive: "Automotive Retail & Aftermarket",
      fintech: "Fintech Startups",
      hrtech: "HR, Recruiting & Staffing",
      family_office: "Family Offices & Private Wealth",
    },
  },
  ar: {
    nav: {
      services: "الخدمات",
      industries: "القطاعات",
      method: "المنهجية",
      healthcheck: "الفحص المالي",
      contact: "تواصل",
      cta: "الفحص المجاني",
    },
    hero: {
      overline: "متوافق مع رؤية 2030 · الرياض",
      title: "وضوح مالي لشركات المملكة الطموحة.",
      sub: "مراجعة الإدارة المالية من كابيتال باي تكشف السيولة المخفية، وتعزز الضوابط، وتُجهز أعمالك للتمويل والنمو والامتثال للزكاة وضريبة القيمة المضافة.",
      cta1: "ابدأ الفحص المالي للرؤساء التنفيذيين",
      cta2: "تحدث عبر واتساب",
      stat1: "+120",
      stat1l: "مشروع لشركات صغيرة ومتوسطة",
      stat2: "12%",
      stat2l: "متوسط تحسين الهامش",
      stat3: "10",
      stat3l: "قطاعات سعودية رئيسية",
      stat4: "10 أيام",
      stat4l: "حتى أول النتائج",
    },
    industries: {
      overline: "مصمم لقطاعك",
      title: "خبرة متخصصة في أكثر من 24 قطاعًا سعوديًا.",
      sub: "من الصناعات الكبرى إلى المكاتب الاستشارية البوتيك والاستشاريين المستقلين — تتم معايرة منهجيات المراجعة المالية لدينا وفقًا للواقع التشغيلي ومؤشرات الأداء والمتطلبات التنظيمية لكل قطاع.",
    },
    services: {
      overline: "ما نقدمه",
      title: "مراجعة الإدارة المالية — وكل ما يدور حولها.",
      sub: "مشروع يقوده شركاء كبار يمنح الرؤساء التنفيذيين صورة واضحة وقابلة للتنفيذ خلال 4–6 أسابيع.",
      items: [
        { t: "مراجعة الإدارة المالية", d: "تشخيص شامل للتدفق النقدي والربحية والامتثال والضوابط وجاهزية النمو مع خارطة طريق بأولويات." },
        { t: "الضوابط الداخلية والمخاطر", d: "فصل الصلاحيات ومصفوفات الاعتماد وتقييم مخاطر الاحتيال واختبار ضوابط مماثلة لـ SOX." },
        { t: "الزكاة وضريبة القيمة المضافة والفوترة", d: "تسوية الإقرارات وجاهزية الفوترة الإلكترونية (المرحلة 2) وتوثيق السياسات." },
        { t: "التخطيط المالي ولوحات المعلومات", d: "توقعات متجددة وحزم مجلس الإدارة ولوحات مؤشرات تُسلَّم خلال 10 أيام من نهاية الشهر." },
        { t: "تحسين رأس المال العامل", d: "إعادة ضبط أيام التحصيل والسداد والمخزون وتحسين دورة التحول النقدي." },
        { t: "جاهزية التمويل والمستثمرين", d: "مذكرات معلومات وقوائم متوافقة مع IFRS وغرف بيانات لجولات التمويل." },
      ],
    },
    method: {
      overline: "منهجيتنا",
      title: "مراجعة من أربع مراحل مصممة للوضوح والسرعة.",
      steps: [
        { n: "01", t: "اكتشاف", d: "مقابلات مع أصحاب المصلحة وطلب الوثائق ومقارنة مرجعية مع قطاعك." },
        { n: "02", t: "تشخيص", d: "مراجعة كمية عبر خمس ركائز مالية وتحليل للأسباب الجذرية." },
        { n: "03", t: "تصميم", d: "خارطة طريق ذات أولوية ومكاسب سريعة وخطة تحوّل لمدة 12 شهرًا." },
        { n: "04", t: "تنفيذ", d: "تقرير جاهز للمجلس وورشة تنفيذية ومتابعة تنفيذ لمدة 90 يومًا." },
      ],
    },
    quiz: {
      overline: "أداة مجانية",
      title: "الفحص المالي للرؤساء التنفيذيين",
      sub: "12 سؤالًا. 4 دقائق. درجة شخصية وتفصيل حسب الفئة وأهم ثلاث فرص تحسين لشركتك — معايرة حسب قطاعك.",
      pickIndustry: "١. اختر قطاعك",
      pickIndustrySub: "اختر القطاع الذي يصف عملك الأساسي.",
      next: "متابعة",
      back: "السابق",
      submit: "احسب درجتي",
      progress: "سؤال",
      of: "من",
      qHelp: "اختر الإجابة التي تعكس واقعك الحالي.",
      ans: { yes: "نعم — مطبق بالكامل", partial: "جزئيًا / أحيانًا", no: "لا / ليس بعد" },
      formTitle: "٢. أين نرسل لك التقرير؟",
      formSub: "سنعرض درجتك على الشاشة ونرسل تقريرًا مفصلًا بصيغة PDF.",
      f: {
        name: "الاسم الكامل",
        role: "المنصب",
        email: "البريد الإلكتروني للعمل",
        phone: "الهاتف (مع رمز الدولة)",
        company: "اسم الشركة",
        size: "حجم الشركة",
        sizes: ["1–10 موظفين", "11–50", "51–200", "201–500", "+500"],
        consent: "أوافق على التواصل معي بشأن نتائجي.",
      },
      results: {
        title: "درجتك في الإدارة المالية",
        sub: "إليك ترتيب وظيفتك المالية عبر الركائز الخمس التي نراجعها.",
        gradeLabel: "التقدير العام",
        recsTitle: "أهم ٣ أولويات لك",
        cta: "احجز مكالمة عبر واتساب",
        share: "شارك على لينكدإن",
        restart: "افحص مرة أخرى",
      },
      cats: {
        cash_flow: "التدفق النقدي",
        profitability: "الربحية",
        compliance: "الامتثال",
        controls: "الضوابط",
        growth: "جاهزية النمو",
      },
    },
    why: {
      overline: "لماذا كابيتال باي",
      title: "مستشارون كبار. خبرة سعودية. مخرجات جاهزة للمجلس.",
      items: [
        { t: "بقيادة الشركاء", d: "كل مشروع يقوده شركاء بخبرات Big-4 — وليس مبتدئين." },
        { t: "عمق السوق السعودي", d: "إجادة كاملة في الزكاة وضريبة القيمة المضافة والفوترة وساما وهيئة السوق المالية ورؤية 2030." },
        { t: "تنفيذ ثنائي اللغة", d: "تقارير وورش عمل ولوحات معلومات بالعربية والإنجليزية." },
        { t: "نتائج قابلة للقياس", d: "نتائج مرتبطة بأثر مالي قابل للقياس — وليس مجرد ممارسات عامة." },
      ],
    },
    testimonials: {
      overline: "آراء الرؤساء التنفيذيين",
      title: "موثوق به من قِبَل المؤسسين والمجموعات العائلية والشركات المدعومة.",
      items: [
        { q: "أعادت كابيتال باي بناء توقعات السيولة لدينا وحررت 6.4 مليون ريال من رأس المال العامل خلال 90 يومًا.", a: "الرئيس التنفيذي، مجموعة أغذية، الرياض" },
        { q: "منحت المراجعة مجلسنا الوضوح اللازم قبل جولة التمويل (B). جاهزون للمستثمرين خلال ستة أسابيع.", a: "مؤسس، شركة تقنية، جدة" },
        { q: "وفّر علينا تصحيح المرحلة الثانية للفوترة الإلكترونية تعرضًا ماليًا كبيرًا.", a: "المدير المالي، شركة تصنيع، الدمام" },
      ],
    },
    faq: {
      overline: "أسئلة",
      title: "الأسئلة الشائعة.",
      items: [
        { q: "كم تستغرق مراجعة الإدارة المالية؟", a: "عادة 4–6 أسابيع حسب حجم الشركة وجاهزية البيانات. النتائج الأولية تُشارك خلال 10 أيام عمل." },
        { q: "هل تعملون مع شركات خارج الرياض؟", a: "نعم. نخدم الشركات الصغيرة والمتوسطة في جميع مناطق المملكة." },
        { q: "هل الفحص المالي مجاني فعلًا؟", a: "نعم — الاختبار والدرجة والتوصيات الثلاث الأولى مجانية. المراجعة الكاملة مشروع منفصل." },
        { q: "هل تبقى بياناتي سرية؟", a: "بالتأكيد. نوقع اتفاقيات سرية مع كل عميل." },
        { q: "هل تدعمون المرحلة الثانية للفوترة الإلكترونية؟", a: "نعم — تقييم جاهزية وتصميم تكامل ومتابعة بعد الإطلاق." },
      ],
    },
    contact: {
      overline: "تواصل معنا",
      title: "لنتحدث عن وظيفتك المالية.",
      sub: "أرسل رسالة أو تحدث معنا فورًا عبر واتساب.",
      name: "الاسم",
      email: "البريد",
      phone: "الهاتف",
      company: "الشركة",
      message: "كيف يمكننا مساعدتك؟",
      send: "إرسال الرسالة",
      address: "الملز، الرياض، المملكة العربية السعودية",
      email_label: "البريد",
      email_value: "capital.bay@outlook.com",
      phone_label: "واتساب",
      phone_value: "",
      sent: "تم إرسال الرسالة. سنرد خلال يوم عمل واحد.",
    },
    footer: {
      tag: "مراجعة الإدارة المالية للشركات السعودية الصغيرة والمتوسطة.",
      links: "روابط",
      services: "الخدمات",
      industries: "القطاعات",
      contact: "تواصل",
      healthcheck: "الفحص المالي",
      copyright: "© كابيتال باي للاستشارات وحلول الإدارة. جميع الحقوق محفوظة.",
      vision: "متوافق مع رؤية المملكة 2030",
    },
    industriesList: {
      oil_gas: "النفط والغاز والبتروكيماويات",
      construction: "البناء والعقارات",
      retail: "التجزئة والتجارة الإلكترونية",
      healthcare: "الرعاية الصحية والأدوية",
      manufacturing: "التصنيع والصناعة",
      hospitality: "السياحة والضيافة",
      logistics: "اللوجستيات والنقل",
      financial: "الخدمات المالية",
      ict: "تقنية المعلومات والاتصالات",
      fnb: "الأغذية والمشروبات",
      professional_services: "الخدمات المهنية والقانونية",
      creative_agencies: "الإعلان والوكالات الإبداعية",
      media: "الإعلام والنشر والمحتوى",
      education: "التعليم وتقنيات التعليم",
      architecture: "الهندسة المعمارية والاستشارية",
      beauty_wellness: "التجميل والسبا والعافية",
      fitness: "اللياقة والرياضة",
      events: "الفعاليات والترفيه",
      renewables: "الطاقة المتجددة والتقنيات النظيفة",
      agritech: "الزراعة والتقنية الزراعية",
      automotive: "قطاع السيارات وقطع الغيار",
      fintech: "شركات التقنية المالية الناشئة",
      hrtech: "الموارد البشرية والتوظيف",
      family_office: "المكاتب العائلية والثروات الخاصة",
    },
  },
};
